import BillboardList from './BillboardList'

export default {
  BillboardList
}
